import { useFindFaireDirectBrandTokenOrAliasForCurrentPage } from "@faire/deprecated-retailer-visitor-shared/app/_lib/faire-direct-visitor/faire-direct/useFindFaireDirectBrandTokenOrAliasForCurrentPage";
import { useFaireDirectInfo } from "@faire/faire-direct/lib/hooks/useFaireDirectInfo/useFaireDirectInfo";
import { useIsFaireDirectActiveInLoggedOut } from "@faire/faire-direct/lib/hooks/useIsFaireDirectActiveInLoggedOut/useIsFaireDirectActiveInLoggedOut";
import { useFaireDirectBrandForVisitorQuery } from "@faire/faire-direct/lib/visitor/useFaireDirectBrandForVisitorQuery";
import { useFaireDirectBrandTokenAndAlias } from "@faire/faire-direct/lib/visitor/useFaireDirectBrandTokenAndAlias";
import { useFaireDirectInfoForXP } from "@faire/faire-direct/lib/visitor/useFaireDirectInfoForXP";
import { useIsFaireDirectActiveForVisitor } from "@faire/faire-direct/lib/visitor/useIsFaireDirectBrandForVisitor";
import { optimizeImageUrl } from "@faire/web/common/transform-images";

import { MaybeFaireDirectBrandBannerImage } from "./MaybeFaireDirectBrandBannerImage";

export const MaybeFaireDirectBrandBannerImageWithHook: React.FC = () => {
  const { faireDirectBrandToken: brandTokenFromInfo } = useFaireDirectInfo();
  const isFaireDirectActiveInLoggedOut = useIsFaireDirectActiveInLoggedOut();

  const brandTokenOrBrandAlias =
    useFindFaireDirectBrandTokenOrAliasForCurrentPage();
  const { brandToken: brandTokenFromTreatment } =
    useFaireDirectBrandTokenAndAlias(brandTokenOrBrandAlias);

  const faireDirectBrandToken = useFaireDirectInfoForXP(
    brandTokenFromInfo,
    brandTokenFromTreatment
  );
  const isFaireDirectActiveForVisitor = useIsFaireDirectActiveForVisitor(
    brandTokenOrBrandAlias,
    isFaireDirectActiveInLoggedOut
  );

  const faireDirectBrand = useFaireDirectBrandForVisitorQuery(
    faireDirectBrandToken,
    isFaireDirectActiveForVisitor
  );

  if (!faireDirectBrand?.banner_image) {
    return null;
  }

  const bannerImageSrc = optimizeImageUrl(
    faireDirectBrand.banner_image,
    false,
    {
      height: 96,
    }
  );

  return <MaybeFaireDirectBrandBannerImage bannerImageSrc={bannerImageSrc} />;
};
